<template>
  <div>
    <md-table v-model="users.data" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="N° de factura">{{
          item.num_factura
        }}</md-table-cell>
        <md-table-cell md-label="Name">{{ item.nombre }}</md-table-cell>
        <md-table-cell md-label="Telefono">{{ item.telefono }}</md-table-cell>
        <md-table-cell md-label="Seña">{{ item.sena }}</md-table-cell>
        <md-table-cell md-label="A pagar">{{ item.resto }}</md-table-cell>
        <md-table-cell md-label="Total">{{ item.precio_total }}</md-table-cell>
        <md-table-cell md-label="Fecha y Hora"
          >{{ item.fecha }} {{ item.hora }}</md-table-cell
        >
        <md-table-cell md-label="Estado">{{ item.estado }}</md-table-cell>
        <md-table-cell md-label="Opciones">
          <router-link
            v-if="item.estado == 'pendiente'"
            active-class="active"
            :to="{ name: 'Pedido Detalle', params: { id: item.num_factura } }"
            ><md-icon style="color: sky">visibility</md-icon
            ><md-tooltip md-direction="top">Detalles</md-tooltip></router-link
          >
          <router-link
            v-if="item.estado == 'pendiente' || item.estado == 'postergado'"
            active-class="active"
            :to="{ name: 'Editar Pedido', params: { id: item.num_factura } }"
            ><md-icon style="color: orange">edit</md-icon
            ><md-tooltip md-direction="top">Editar</md-tooltip></router-link
          >
          <a
            v-if="item.estado == 'pendiente'"
            v-on:click="Delete(item.num_factura)"
            ><md-icon style="color: red">delete_forever</md-icon
            ><md-tooltip md-direction="top">Eliminar</md-tooltip></a
          >
          <a
            v-if="item.estado == 'pendiente'"
            v-on:click="getStado(item.num_factura, item.id, 'entregadot')"
            ><md-icon style="color: green">payment</md-icon
            ><md-tooltip md-direction="top"
              >Completar con tarjeta</md-tooltip
            ></a
          >
          <a
            v-if="item.estado == 'pendiente'"
            v-on:click="getStado(item.num_factura, item.id, 'entregadof')"
            ><md-icon style="color: green">local_atm</md-icon
            ><md-tooltip md-direction="top"
              >Completar con efectivo</md-tooltip
            ></a
          >
          <a
            v-if="item.estado == 'pendiente'"
            v-on:click="getStado(item.num_factura, item.id, 'postergado')"
            ><md-icon style="color: violet">archive</md-icon
            ><md-tooltip md-direction="top">Postergar</md-tooltip></a
          >
          <a
            v-if="item.estado == 'postergado'"
            v-on:click="getStado(item.num_factura, item.id, 'pendiente')"
            ><md-icon style="color: green">unarchive</md-icon
            ><md-tooltip md-direction="top">Volver a pendiente</md-tooltip></a
          >
          <a
            v-if="item.estado == 'entregado'"
            v-on:click="getStado(item.num_factura, item.id, 'pendiente')"
            ><md-icon style="color: red">undo</md-icon
            ><md-tooltip md-direction="top">Volver a pendiente</md-tooltip></a
          >
          <router-link
            v-if="item.estado == 'pendiente'"
            active-class="active"
            :to="{ name: 'Sena', params: { id: item.num_factura } }"
            ><md-icon style="color: blue">attach_money</md-icon
            ><md-tooltip md-direction="top">Nueva seña</md-tooltip></router-link
          >
        </md-table-cell>
      </md-table-row>
    </md-table>
    <hr />
    <md-table>
      <md-table-row>
        <md-button class="md-warning" v-on:click="Anterior()"
          >Anterior</md-button
        >
        <md-button class="md-warning" disabled
          >{{ page }} de {{ pages }}</md-button
        >
        <md-button class="md-warning" v-on:click="Siguiente()"
          >Siguiente</md-button
        >
      </md-table-row>
    </md-table>
    <md-card
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      style="margin: 10px"
    >
      <md-card-content>

        <md-field>
          <label for="first-name">Buscar...</label>
          <md-input name="first-name" id="first-name" autocomplete="given-name"  v-model="buscarnombreetc"/>
        <md-button class="md-button md-success" v-on:click="buscarnombre()">
          <md-icon>search</md-icon>
        </md-button>
        </md-field>
        <md-radio v-model="radio" v-on:change="SetEstado()" value="entregado"
          >Entregado</md-radio
        >
        <md-radio v-model="radio" v-on:change="SetEstado()" value="pendiente"
          >Pendientes</md-radio
        >
        <md-radio v-model="radio" v-on:change="SetEstado()" value="postergado"
          >Postegados</md-radio
        >
        <md-datepicker v-model="fecha">
          <label>Desde</label>
        </md-datepicker>
        <md-datepicker v-model="fechahasta">
          <label>Hasta</label>
        </md-datepicker>
        <md-button class="md-button" v-on:click="SetFecha()">
          <md-icon>event_available</md-icon>
        </md-button>

        <md-button class="md-button md-primary" v-on:click="Reset()">
          <md-icon>cached</md-icon>
        </md-button>

        <md-button class="md-button md-info" v-on:click="getPdf()">
          <md-icon>print</md-icon>
        </md-button>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import axios from "axios";
import Global from "../../Global";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "simple-table",
  props: {
    tableHeaderColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selected: [],
      users: [],
      pdf: [],
      titulopdf: null,
      page: 1,
      pages: null,
      url: Global.url,
      active: false,
      value: null,
      radio: "pendiente",
      fecha: null,
      fechahasta: null,
      buscarnombreetc: null,
      urlconsulta: "/getpedido/pendiente/0/0",
    };
  },
  mounted() {
    this.getPedidos(this.radio, this.fecha);
  },
  methods: {
    getPedidos(radio, fecha, fechahasta, buscarnombre) {
    if (!buscarnombre) {
      if (fecha == null) {
        this.urlconsulta ="getpedido/pendiente/0/0"
        axios
          .get(this.url + "getpedido/" + radio +"/0/0?page=" + this.page, {
            headers: { ApiToken: localStorage.usertoken }
          })
          .then(res => {
            this.users = res.data;
            this.pages = res.data.last_page;
          });
      } else {
        if (fechahasta == null) {
          this.urlconsulta ="getpedido/"+radio+"/"+this.$moment(fecha).format("Y-MM-DD") +"/0"
          axios
            .get(
              this.url +
                "getpedido/" +
                radio +
                "/" +
                this.$moment(fecha).format("Y-MM-DD") +"/0?page=" +
                this.page,
              {
                headers: { ApiToken: localStorage.usertoken }
              }
            )
            .then(res => {
              this.users = res.data;
              this.pages = res.data.last_page;
            });
        } else {
          this.urlconsulta ="getpedido/"+radio+"/"+this.$moment(fecha).format("Y-MM-DD") +"/"+this.$moment(fechahasta).format("Y-MM-DD")
          axios
            .get(
              this.url +
                "getpedido/" +
                radio +
                "/" +
                this.$moment(fecha).format("Y-MM-DD") +
                "/" +
                this.$moment(fechahasta).format("Y-MM-DD") +
                "?page=" +
                this.page,
              {
                headers: { ApiToken: localStorage.usertoken }
              }
            )
            .then(res => {
              this.users = res.data;
              this.pages = res.data.last_page;
            });
        }
      }
    }else{
      if (fecha == null) {
        this.urlconsulta ="getpedido/"+radio+"/0/0/"+buscarnombre
        axios
          .get(this.url + "getpedido/" + radio +"/0/0/"+buscarnombre+"?page=" + this.page, {
            headers: { ApiToken: localStorage.usertoken }
          })
          .then(res => {
            this.users = res.data;
            this.pages = res.data.last_page;
          });
      } else {
        if (fechahasta == null) {
          this.urlconsulta ="getpedido/"+radio+"/"+this.$moment(fecha).format("Y-MM-DD") +"/0/"+buscarnombre
          axios
            .get(
              this.url +
                "getpedido/" +
                radio +
                "/" +
                this.$moment(fecha).format("Y-MM-DD") +"/0/"+buscarnombre+"?page=" +
                this.page,
              {
                headers: { ApiToken: localStorage.usertoken }
              }
            )
            .then(res => {
              this.users = res.data;
              this.pages = res.data.last_page;
            });
        } else {
          this.urlconsulta ="getpedido/"+radio+"/"+this.$moment(fecha).format("Y-MM-DD") +"/"+this.$moment(fechahasta).format("Y-MM-DD")+"/"+buscarnombre
          axios
            .get(
              this.url +
                "getpedido/" +
                radio +
                "/" +
                this.$moment(fecha).format("Y-MM-DD") +
                "/" +
                this.$moment(fechahasta).format("Y-MM-DD") + "/" + buscarnombre +
                "?page=" +
                this.page,
              {
                headers: { ApiToken: localStorage.usertoken }
              }
            )
            .then(res => {
              this.users = res.data;
              this.pages = res.data.last_page;
            });
        }
      }
    }
    },
    Siguiente() {
      if (this.page + 1 <= this.pages) {
        axios
          .get(this.users.next_page_url, {
            headers: { ApiToken: localStorage.usertoken }
          })
          .then(res => {
            this.users = res.data;
            this.pages = res.data.last_page;
            this.page = res.data.current_page;
          });
      }
    },
    Anterior() {
      if (this.page - 1 > 0) {
        axios
          .get(this.users.prev_page_url, {
            headers: { ApiToken: localStorage.usertoken }
          })
          .then(res => {
            this.users = res.data;
            this.pages = res.data.last_page;
            this.page = res.data.current_page;
          });
      }
    },
    Delete(id) {
      if (confirm("Seguro quieres eliminar el pedido N° " + id)) {
        axios
          .delete(this.url + "pedido/" + id, {
            headers: { ApiToken: localStorage.usertoken }
          })
          .then(response => {
            if (response.status == 200) {
              this.getPedidos(this.radio, this.fecha, this.fechahasta);
            }
          });
      }
    },
    getStado(num_factura, id, estado) {
      var mensaje = estado;

      if (estado == "entregadof") {
        mensaje = "Entregado y pagado con Efectivo";
      }
      if (estado == "entregadot") {
        mensaje = "Entregado y pagado con Tarjeta";
      }

      if (
        confirm(
          "Seguro quieres registrar el pedido N° " + id + " como " + mensaje
        )
      ) {
        axios
          .get(this.url + "pedido/completado/" + id + "/" + estado, {
            headers: { ApiToken: localStorage.usertoken }
          })
          .then(response => {
            this.getPedidos(this.radio, this.fecha, this.fechahasta);
          });
      }
    },
    SetEstado() {
      this.getPedidos(this.radio, this.fecha, this.fechahasta);
    },
    SetFecha() {
      this.getPedidos(this.radio, this.fecha, this.fechahasta);
    },
    buscarnombre(){
      this.getPedidos(this.radio, this.fecha, this.fechahasta, this.buscarnombreetc);
    },
    Reset() {
      this.radio = "pendiente";
      this.fecha = null;
      this.fechahasta = null;

      this.getPedidos(this.radio, this.metodo, this.fecha, this.fechahasta);
    },
    getPdf() {
          axios
          .get(this.url+"pdf/"+this.urlconsulta, {
            headers: { ApiToken: localStorage.usertoken }
          })
          .then(res => {
            this.titulopdf = "| " + this.radio;
            this.pdf = res.data;
            this.exportPDF();
          })
        .catch(error => {
          alert(error);
        });;
    },
    exportPDF() {
      var vm = this;

      var columns = [
        { title: "N° de factura", dataKey: "num_factura" },
        { title: "Nombre", dataKey: "nombre" },
        { title: "Pedido", dataKey: "descripcion" },
        { title: "A pagar", dataKey: "resto" },
        { title: "Fecha", dataKey: "fecha" },
        { title: "Hora", dataKey: "hora" }
      ];
      var doc = new jsPDF("p", "pt");
      doc.text("Pedidos " + vm.titulopdf, 40, 40);
      doc.autoTable(columns, vm.pdf, {
        margin: { top: 60 },
        columnStyles: {
          0: {columnWidth: 50},
          1: {columnWidth: 100},
          2: {columnWidth: 200},
          3: {columnWidth: 50},
          4: {columnWidth: 60},
          5: {columnWidth: 50},
        }
      });
      doc.save("pedidos.pdf");
    }
  }
};
</script>
